export const RECAPTCHA_ENTERPRISE_SCRIPT_URL = 'https://www.google.com/recaptcha/enterprise.js';

/**
 * Loads Google reCAPTCHA Enterprise on the parent page that hosts Zuora Payment Pages.
 * Required when Zuora CAPTCHA (implicit / AI Assessment) is enabled.
 * Idempotent — reuses an existing script tag if already present.
 * @return {Promise<HTMLScriptElement>} A promise that resolves to the loaded script element.
 */
export function loadRecaptchaEnterpriseScript(): Promise<HTMLScriptElement> {
  const existing = document.querySelector<HTMLScriptElement>(`script[src="${RECAPTCHA_ENTERPRISE_SCRIPT_URL}"]`);
  if (existing) {
    return Promise.resolve(existing);
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = RECAPTCHA_ENTERPRISE_SCRIPT_URL;
    script.async = true;
    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA Enterprise script'));
    document.head.appendChild(script);
  });
}
